import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, Typography } from "antd";
import { useLogin } from "../hooks/useAuth";

const { Title, Text } = Typography;

export function LoginForm() {
	const [form] = Form.useForm<any>();
	const { mutate: login, isPending } = useLogin();

	const onFinish = (values: any) => {
		const rawUsername = values.username.trim();
		const isPhone = /^\d{9}$/.test(rawUsername.replace(/\s+/g, ""));
		const username = isPhone ? `+998${rawUsername.replace(/\s+/g, "")}` : rawUsername;

		login({ username, password: values.password });
	};

	return (
		<Card className="w-full max-w-md shadow-lg">
			<div className="text-center mb-8">
				<Title level={2} className="!mb-2">
					QurilishCRM
				</Title>
				<Text type="secondary">Tizimga kirish</Text>
			</div>

			<Form form={form} name="login" onFinish={onFinish} layout="vertical" requiredMark={false}>
				<Form.Item
					name="username"
					label="Foydalanuvchi nomi yoki telefon"
					rules={[
						{
							required: true,
							message: "Iltimos, foydalanuvchi nomi yoki telefon raqamini kiriting",
						},
						{ min: 3, message: "Kamida 3 ta belgi bo'lishi kerak" },
					]}
				>
					<Input
						prefix={<UserOutlined className="text-gray-400" />}
						placeholder="admin yoki 901234567"
						autoComplete="username"
					/>
				</Form.Item>

				<Form.Item
					name="password"
					label="Parol"
					rules={[
						{ required: true, message: "Iltimos, parolingizni kiriting" },
						{ min: 4, message: "Parol kamida 4 ta belgidan iborat bo'lishi kerak" },
					]}
				>
					<Input.Password
						prefix={<LockOutlined className="text-gray-400" />}
						placeholder="Parol"
						autoComplete="current-password"
					/>
				</Form.Item>

				<Form.Item className="!mb-0">
					<Button type="primary" htmlType="submit" loading={isPending} block>
						Kirish
					</Button>
				</Form.Item>
			</Form>
		</Card>
	);
}
